import {Box} from "@mui/material";

import React, {useEffect, useState} from "react";
import {ContentWrapper} from "../../components/ContentWrapper";
import {Loading} from "../../components/Loading";
import {CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis} from 'recharts';
import {findAllPropositions} from "../../database/queries/queries";
import moment from "moment"
import {Proposition} from "../../utils/types";

function unique(value: string, index: number, array: string[]) {
    return array.indexOf(value) === index;
}

export const DashboardApp = () => {

    const [isLoading, setLoading] = useState(false)
    const [newPropositionsPerDay, setNewPropositionsPerDay] = useState<{ name: string; value: number; }[]>([])
    const [votesPerDay, setVotesPerDay] = useState<{ name: string; value: number; }[]>([])

    useEffect(() => {
        findAllPropositions().then((result: Awaited<Proposition>[]) => {

            const _propositionsPerDay = result.reverse().reduce((acc, proposition) => {
                const key = moment(proposition.createdAt.toDate()).format("DD/MM/YYYY"); // Convert to string or use a specific format based on your requirements
                if (!acc.has(key)) {
                    acc.set(key, {name: key, value: 1})
                } else {
                    acc.get(key)!.value += 1
                }

                return acc;
            }, new Map<string, { name: string; value: number }>);
            
            setNewPropositionsPerDay(Array.from(_propositionsPerDay.values()))


            const _votesPerDay = result.reduce((acc, proposition) => {
                proposition.votes.map(v => {
                    const key = moment(v.createdAt.toDate()).format("DD/MM/YYYY"); // Convert to string or use a specific format based on your requirements

                    if (!acc.has(key)) {
                        acc.set(key, {name: key, value: 1})
                    } else {
                        acc.get(key)!.value += 1
                    }
                })


                return acc;
            }, new Map<string, { name: string; value: number }>);
            setVotesPerDay(Array.from(_votesPerDay.values()))

        })

    }, []);

    if (isLoading) {
        return <Loading/>
    }

    return (<Box sx={{pb: 8}}>
        <ContentWrapper hasScroll>
        <Box sx={{ padding: 4, display: "flex", flexDirection: "column" }}>
            <h1>Métricas do Aplicativo</h1>

            <div>
                    <h2>Big Numbers</h2>
                   <iframe
                   title="Título do Iframe"
                   width="640"
                   height="355"
                   src="https://datastudio.google.com/embed/reporting/c04b7661-1ef9-4e14-bd07-6175440881b6/page/p_1hs0nxb2fd"
                   frameBorder="0"
                   allowFullScreen
                   ></iframe>

                </div>
                <div>
                    <h2>Novas propostas por dia</h2>
                    <LineChart width={500} height={300} data={newPropositionsPerDay}>
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="name"/>
                        <YAxis/>
                        <Tooltip/>
                        <Line type="monotone" dataKey="value" stroke="#8884d8"/>
                    </LineChart>
                </div>

                <div>
                    <h2>Votos por dia</h2>
                    <LineChart width={500} height={300} data={votesPerDay}>
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="name"/>
                        <YAxis/>
                        <Tooltip/>
                        <Line type="monotone" dataKey="value" stroke="#8884d8"/>
                    </LineChart>
                </div>
                <div>
                    <h2>Mapa de propostas</h2>
                   <iframe
                   title="Título do Iframe"
                   width="640"
                   height="355"
                   src="https://datastudio.google.com/embed/reporting/12ac3f57-eae6-4cea-a478-0ce1290e66e0/page/p_v5oojfvaid"
                   frameBorder="0"
                   allowFullScreen
                   ></iframe>

                </div>

            </Box>
        </ContentWrapper>
    </Box>);
}